import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { MdbGlobalModule } from 'src/app/shared/mdb-global.module';
import { DashboardModule } from 'src/app/shared/shared-dashboard/dashboard.module';

import { DxButtonModule, DxTagBoxModule, DxScrollViewModule, DxTextBoxModule, DxDataGridModule, DxPopupModule, DxSelectBoxModule, DxDateBoxModule, DxRadioGroupModule, DxCheckBoxModule, DxAccordionModule } from "devextreme-angular";
import { SharedDatagridModule } from 'src/app/shared/shared-datagrid/shared-datagrid.module';
import { SignaturePadModule } from 'angular2-signaturepad';
import { AccountAndServicesComponent } from './account-services.component';
@NgModule({
  declarations: [
    AccountAndServicesComponent
  ],
  imports: [
    SignaturePadModule,
    CommonModule,
    ReactiveFormsModule,
    MdbGlobalModule,
    DashboardModule,
    DxButtonModule,
    DxTagBoxModule,
    DxScrollViewModule,
    DxTextBoxModule,
    DxDataGridModule,
    DxPopupModule,
    DxSelectBoxModule,
    DxDateBoxModule,
    DxRadioGroupModule,
    DxCheckBoxModule,
    DxAccordionModule,
    SharedDatagridModule
  ], exports: [
    AccountAndServicesComponent
  ]
})
export class AccountAndServicesModule { }
